(function () {
  var drawer = document.querySelector('[data-search-drawer]');
  if (!drawer) return;

  var form = drawer.querySelector('[data-search-drawer-form]');
  var input = drawer.querySelector('[data-search-drawer-input]');
  var results = drawer.querySelector('[data-search-drawer-results]');
  var status = drawer.querySelector('[data-search-drawer-status]');
  if (!form || !input || !results) return;

  var OPEN_CLASS = 'oddit-search-drawer--open';
  var limit = parseInt(drawer.getAttribute('data-search-limit'), 10) || 6;
  var searchUrl = drawer.getAttribute('data-search-url') || '/search';
  var predictiveUrl = drawer.getAttribute('data-predictive-url') || '/search/suggest';

  var debounceTimer = null;
  var requestToken = 0;
  var lastQuery = '';

  function setStatus(message) {
    if (status) status.textContent = message || '';
  }

  function clearResults() {
    results.textContent = '';
    results.hidden = true;
    input.setAttribute('aria-expanded', 'false');
  }

  function formatMoney(price) {
    var amount;
    if (typeof price === 'number') {
      amount = price / 100;
    } else if (typeof price === 'string' && price !== '' && isFinite(price)) {
      amount = parseFloat(price);
    } else {
      return '';
    }
    return '$' + amount.toFixed(2).replace(/\.00$/, '');
  }

  function buildResult(product) {
    var link = document.createElement('a');
    link.className = 'oddit-search-drawer__result';
    link.href = product.url;
    link.setAttribute('role', 'option');
    link.setAttribute('aria-selected', 'false');

    var image = product.featured_image && product.featured_image.url;
    if (image) {
      var imageWrap = document.createElement('span');
      imageWrap.className = 'oddit-search-drawer__result-image';
      var img = document.createElement('img');
      img.src = image.indexOf('?') === -1 ? image + '?width=112' : image + '&width=112';
      img.alt = '';
      img.width = 56;
      img.height = 56;
      img.loading = 'lazy';
      imageWrap.appendChild(img);
      link.appendChild(imageWrap);
    }

    var text = document.createElement('span');
    text.className = 'oddit-search-drawer__result-text';

    var title = document.createElement('span');
    title.className = 'oddit-search-drawer__result-title';
    title.textContent = product.title || '';
    text.appendChild(title);

    var metaParts = [];
    if (product.type) metaParts.push(product.type);
    var price = formatMoney(product.price);
    if (price) metaParts.push(price);
    if (metaParts.length) {
      var meta = document.createElement('span');
      meta.className = 'oddit-search-drawer__result-meta';
      meta.textContent = metaParts.join(' · ');
      text.appendChild(meta);
    }

    link.appendChild(text);
    return link;
  }

  function renderResults(products, query) {
    results.textContent = '';

    if (!products.length) {
      clearResults();
      setStatus('No results for “' + query + '”. Press Enter to search everything.');
      return;
    }

    products.forEach(function (product) {
      results.appendChild(buildResult(product));
    });

    var viewAll = document.createElement('a');
    viewAll.className = 'oddit-search-drawer__view-all';
    viewAll.href = searchUrl + '?q=' + encodeURIComponent(query) + '&type=product';
    viewAll.textContent = 'See all results for “' + query + '”';
    results.appendChild(viewAll);

    results.hidden = false;
    input.setAttribute('aria-expanded', 'true');
    setStatus('');
  }

  function search(query) {
    var token = ++requestToken;
    var url =
      predictiveUrl +
      '?q=' +
      encodeURIComponent(query) +
      '&resources[type]=product&resources[limit]=' +
      limit +
      '&resources[options][unavailable_products]=last';

    setStatus('Searching…');

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Predictive search failed');
        return response.json();
      })
      .then(function (data) {
        if (token !== requestToken) return;
        var products =
          (data && data.resources && data.resources.results && data.resources.results.products) ||
          [];
        renderResults(products, query);
      })
      .catch(function () {
        if (token !== requestToken) return;
        clearResults();
        setStatus('Search is unavailable right now. Press Enter to search the site.');
      });
  }

  function onInput() {
    var query = input.value.trim();
    if (query === lastQuery) return;
    lastQuery = query;

    window.clearTimeout(debounceTimer);

    if (query.length < 2) {
      requestToken++;
      clearResults();
      setStatus('');
      return;
    }

    debounceTimer = window.setTimeout(function () {
      search(query);
    }, 200);
  }

  function open() {
    if (drawer.hidden === false) {
      input.focus();
      return;
    }
    drawer.hidden = false;
    drawer.classList.add(OPEN_CLASS);
    document.addEventListener('keydown', onKeydown);
    input.focus();
  }

  function close() {
    if (drawer.hidden) return;
    window.clearTimeout(debounceTimer);
    requestToken++;
    drawer.hidden = true;
    drawer.classList.remove(OPEN_CLASS);
    document.removeEventListener('keydown', onKeydown);
    clearResults();
    setStatus('');
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      close();
      return;
    }

    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    var options = results.querySelectorAll('.oddit-search-drawer__result');
    if (!options.length) return;

    e.preventDefault();
    var current = -1;
    for (var i = 0; i < options.length; i++) {
      if (options[i] === document.activeElement) {
        current = i;
        break;
      }
    }

    var next;
    if (e.key === 'ArrowDown') {
      next = current + 1 >= options.length ? 0 : current + 1;
    } else {
      next = current <= 0 ? options.length - 1 : current - 1;
    }

    for (var j = 0; j < options.length; j++) {
      options[j].setAttribute('aria-selected', j === next ? 'true' : 'false');
    }
    options[next].focus();
  }

  input.addEventListener('input', onInput);

  var closers = drawer.querySelectorAll('[data-search-drawer-close]');
  for (var c = 0; c < closers.length; c++) {
    closers[c].addEventListener('click', close);
  }

  form.addEventListener('submit', function (e) {
    if (input.value.trim() === '') e.preventDefault();
  });

  window.OdditSearchDrawer = {
    open: open,
    close: close,
    toggle: function () {
      if (drawer.hidden) {
        open();
      } else {
        close();
      }
    }
  };
})();
